import React, {memo, useMemo} from 'react';
import styles from './styles.module.scss';
import {t} from "i18next";
import {s} from "@/app/utils/s";
import {SkillLevelEnum} from "@/app/api/user";
import SelectionWidget from "@/app/components/selection_widget";
import {SkillLevelOpenMatchEnum} from "@/app/api/open_match";

interface Props {
  onSelect?: (value: SkillLevelOpenMatchEnum) => void;
  value?: SkillLevelOpenMatchEnum;
}

const SkillLevelWidget: React.FC<Props> = ({onSelect, value}) => {
  const options = useMemo(() => [
    { value: SkillLevelOpenMatchEnum.BEGINNER, label: t(s.beginner) },
    { value: SkillLevelOpenMatchEnum.INTERMEDIATE, label: t(s.intermediate) },
    { value: SkillLevelOpenMatchEnum.ADVANCED, label: t(s.advanced) },
  ], []);

  return (
    <SelectionWidget
      title={t(s.selectSkillLevel)}
      options={options}
      selectedValue={value}
      onSelect={onSelect}
      className={styles.skillLevelWidget}
    />
  );
};

export default memo(SkillLevelWidget);
